import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

/**
 * Small arrow-toggle used to collapse/expand the "Details" and
 * "Replies" sections on ticket cards across the Admin, Worker and
 * Colony portals. Defaults to closed unless the ticket is in
 * progress or was opened via a direct link (see callers).
 */
export function CollapseToggle({ open, onClick, label, testid, className = "" }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex w-fit items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-foreground transition-colors ${className}`}
      data-testid={testid}
    >
      {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
      {label}
    </button>
  );
}
